import { MarketingAgentDecisionType } from "@redotech/redo-marketing-common/agent-decision/marketing-agent-decision-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const marketingAgentDecisionTypeSchema = createEnum(
  MarketingAgentDecisionType,
  { enumName: "MarketingAgentDecisionType" },
);

export const getMarketingAgentDecisions = {
  name: "getMarketingAgentDecisions" as const,
  input: z.object({
    teamId: z.string().optional(),
    customerId: z.string().optional(),
    typeFilter: z.array(marketingAgentDecisionTypeSchema).optional(),
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
  }),
  output: z.object({
    decisions: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string(),
        teamName: z.string(),
        customerId: z.string(),
        customerEmail: z.string().optional(),
        type: marketingAgentDecisionTypeSchema,
        trigger: z.string().optional(), // Event trigger for Sentinel decisions only
        outcome: z.string(),
        outcomeTooltip: z.string().optional(),
        createdAt: z.date(),
        finishedAt: z.date(),
      }),
    ),
    totalCount: z.number(),
  }),
};
